import { Expander, ExpanderContent, ExpanderHeader, ResponsiveTableRow, H5 } from '@fs/zion-ui'
import { React, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { v4 } from 'uuid'
import { DmcResponsiveTable } from '../../common/DmcResponsiveTable'
import useArtifactEventsPatrons from '../../../hooks/artifacts/useArtifactEventsPatrons'
import PatronDialogOverlay from '../overlay/PatronDialogOverlay'
import { toLocaleString } from '../../../util/DateUtil'

/**
 * Displays information about recent events for the artifact.
 * The patron ID for each event can be clicked to display an info popover.
 */
export default function EventsPanel({ events }) {
  const [t] = useTranslation()
  const [open, setOpen] = useState(events && events.length > 0)
  const patronIds = useMemo(
    () => events && events.flatMap((event) => [event.initiatorPatronId, event.submitterPatronId]),
    [events]
  )
  const { artifactEventsPatrons } = useArtifactEventsPatrons(patronIds, patronIds)
  const columnHeaders = [
    t('action.action', 'Action'),
    t('artifacts.contributorPatronId', 'Contributor Patron ID'),
    t('artifacts.submitterPatronId', 'Submitter Patron ID'),
    t('date', 'Date'),
  ]
  const title = t('artifacts.recentEvents', 'Recent Events')
  let tableRows = []
  if (events !== null && events.length > 0) {
    if (!artifactEventsPatrons) {
      return null
    }
    tableRows = events.map((event) => {
      const eventContributorPatron = artifactEventsPatrons.find((artifactEventContributorPatron) => {
        return artifactEventContributorPatron.id === event.initiatorPatronId
      })
      const eventSubmitterPatron = artifactEventsPatrons.find((artifactEventSubmitterPatron) => {
        return artifactEventSubmitterPatron.id === event.submitterPatronId
      })
      return (
        <ResponsiveTableRow
          key={event.artifactEvent + v4()}
          column1={t(`artifacts.eventType.${event.artifactEvent}`, event.artifactEvent)}
          column2={
            eventContributorPatron ? <PatronDialogOverlay patron={eventContributorPatron} /> : event.initiatorPatronId
          }
          column3={
            eventSubmitterPatron ? <PatronDialogOverlay patron={eventSubmitterPatron} /> : event.submitterPatronId
          }
          column4={event.eventDateTime && toLocaleString(new Date(event.eventDateTime), false)}
          // column4={event.eventDateTime && format(new Date(event.eventDateTime), 'E LLL d yyyy h:mm O')}
        />
      )
    })
  }

  return (
    <Expander open={open} setOpen={setOpen}>
      <ExpanderHeader>
        <H5>{`${title} (${events && events.length > 0 ? tableRows.length : 0})`}</H5>
      </ExpanderHeader>
      <ExpanderContent>
        {tableRows.length > 0 ? (
          <DmcResponsiveTable
            totalColumnCount={columnHeaders.length}
            atSizeColumns={{
              default: {
                labels: columnHeaders,
              },
            }}
            separator={<br />}
          >
            {tableRows}
          </DmcResponsiveTable>
        ) : (
          <H5 supplementary>
            {t('artifacts.noRecentEvents', 'No recent events. Artifact events are stored for 3 months.')}
          </H5>
        )}
      </ExpanderContent>
    </Expander>
  )
}
